import { useState, FC, useEffect } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";
import FinancialSecurityGridPluginSettings from "./FinancialSecurityGridPluginSettings";
import FinancialSecurityGrid from "./FinancialSecurityGrid";

const FinancialSecuritySelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [selectRow, setSelectRow] = useState<ISelectGridRow>()

    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntities ?? []);
    const [focusTaken, setFocusTaken] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false)
    const gridId = uuidv4();
    const plugin = FinancialSecurityGridPluginSettings
    const { t } = useTranslation();

    const isLocked = (isLocked?: boolean) => {
        if (isLocked) {
            renderGlobalAlert({
                variant: "danger",
                title: t('general.goodsIsLocked'),
                statusCode: 500,
            });  
            return false
        }
        return true
    }

    useEffect(() => {
        if (props.dataFromPluginGridSelectorInput)
            setEntities(props.dataFromPluginGridSelectorInput)
    }, [props.dataFromPluginGridSelectorInput])

    return (
        <GridSelectorModalWindow
            gridDisplayName={t('directory.financialSecurity.title')}
            entityToPressEnter={entity}
            focusTaken={focusTaken}
            ok={{
                onClick: () => {
                    if (!isLocked(selectRow?.isLocked)) return
                    props.multipleSelect ? props.ok(entities) : props.ok?.(entity)
                },
                disabled: disabled
            }}
            cancel={{ onClick: () => props.cancel?.() }}>
            {
                plugin
                    ? <FinancialSecurityGrid
                        gridId={gridId}
                        plugin={plugin}
                        data={entities}
                        isModal
                        dataFromPluginGridSelectorInput={props.dataFromPluginGridSelectorInput}
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        isSearchForMultyselect={props.isSearchForMultyselect}
                        onFocusChanged={(taken: boolean) => {
                            setFocusTaken(taken);
                        }}
                        onSelect={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setSelectRow(row)
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                setDisabled(false)
                            } else if (row && rowDto && rowDto.deleted === true) {
                                setDisabled(true)
                            } else if (row) {
                                setDisabled(false)
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                setSelectRow(row)
                            }
                        }}
                        onDoubleClick={(row, rowDto) => {
                            if (!isLocked(row?.isLocked)) return
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                props.ok?.({ idGlobal: row.idGlobal, displayName: row.displayName })
                            }
                        }}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                        }}
                    />
                    : <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default FinancialSecuritySelectorModal